"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs-compat/add/observable/of");
//# sourceMappingURL=of.js.map